export default function getAdressFullString(adresse) {
  return [
    adresse.codePostal || '',
    adresse.adresse1 || '',
    adresse.ville || '',
    adresse.pays || '',
  ].filter(Boolean).join(', ');
}